import { Telemetry, ValidTelemetryEvent } from '../../commonInfra/services/Telemetry';
import { TelemetryEvents } from '../../commonInfra/telemetryEvents/TelemetryEvents';
import { UploadFlowErrorEvent } from '../components/UploadFlowDialog';
import { getFileExtension } from './UploadContentDialogHelper';

export interface UploadFlowEntryPointEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadFlowEntryPoint;
  origin: 'welcome-banner' | 'new-menu';
}

export interface UploadFlowDialogDetailEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadFlowDialogDetails;
  file_selection_type: 'DragDrop' | 'SelectButton';
  file_extension: string;
  file_size_in_kb: number;
  error_event: UploadFlowErrorEvent;
}

export interface UploadFlowActionDetailEvent extends ValidTelemetryEvent {
  type: TelemetryEvents.UploadFlowActionDetails;
  upload_duration_in_ms: number;
  file_size_in_kb: number;
  success: boolean;
  error_message: string;
}

export function sendUploadFlowEntryPointTelemetry(origin: 'welcome-banner' | 'new-menu') {
  Telemetry.sendEvent<UploadFlowEntryPointEvent>({
    type: TelemetryEvents.UploadFlowEntryPoint,
    origin: origin
  });
}

export function sendUploadFlowDialogTelemetry(source: 'DragDrop' | 'SelectButton', file: File, errorEvent: UploadFlowErrorEvent) {
  Telemetry.sendEvent<UploadFlowDialogDetailEvent>({
    type: TelemetryEvents.UploadFlowDialogDetails,
    file_selection_type: source,
    file_extension: getFileExtension(file.name),
    file_size_in_kb: file.size / 1024,
    error_event: errorEvent
  });
}

export function sendUploadFlowActionTelemetry(uploadDurationInMs: number, fileSize: number, isPublishSuccessful: boolean, errorMsg: string) {
  Telemetry.sendEvent<UploadFlowActionDetailEvent>({
    type: TelemetryEvents.UploadFlowActionDetails,
    upload_duration_in_ms: uploadDurationInMs,
    file_size_in_kb: fileSize / 1024,
    success: isPublishSuccessful,
    error_message: errorMsg
  });
}
